import { createFileRoute } from "@tanstack/react-router"

import { PrintProjectPage } from "@/pages/print/print-project-page"
import { requireAuth } from "@/lib/route-guards"

export const Route = createFileRoute("/print/projects/$projectId")({
	beforeLoad: ({ context }) => requireAuth(context),
	component: PrintProjectPage,
})
